// extracted by css-extract-rspack-plugin
export default {"page":"aN4s7KTUiDAlsM72","card":"Ue4VBmbqOAOZpwPv","title":"irTfjQC9ijMlRP2f","body":"El2H7A_kcoYzO96X","actions":"LKaivc8GqMw5fy6Z"};